import { forwardRef } from 'react';

import { TextVariants } from '@lichtblick/theme';
import { TextProps } from '@lichtblick/types';

import { Wrapper } from './Text.styles';

export const Text = forwardRef<HTMLSpanElement, TextProps>(
  ({ $variant = TextVariants.body.l, children, ...rest }: TextProps, ref) => (
    <Wrapper {...rest} $variant={$variant} ref={ref}>
      {children}
    </Wrapper>
  ),
);
